import ProfileAndSettings from './ProfileAndSettings';

export default ProfileAndSettings;
